<template>
    <el-dialog
        :visible.sync="visible"
        append-to-body
        custom-class="tw-w-full md:tw-w-2/5"
    >
        <slot></slot>

        <template slot="footer" class="dialog-footer">
            <button class="btn btn-primary" @click="proceed">{{ proceedLabel }}</button>
            <button v-if="showCancel" class="btn btn-link" @click="close">{{ cancelLabel }}</button>
        </template>
    </el-dialog>
</template>

<script>
    import {Dialog} from 'element-ui';

    export default {
        name: 'ConfirmModal',

        components: {
            'el-dialog': Dialog
        },

        computed: {
            visible: {
                get() {
                    return this.state;
                },

                set() {
                    this.$emit('close', false);
                }
            }
        },

        props: {
            state: {
                type: Boolean,
                default: false
            },

            proceedLabel: {
                type: String,
                default: 'Confirm'
            },

            cancelLabel: {
                type: String,
                default: 'Cancel'
            },

            showCancel: {
                type: Boolean,
                default: true
            }
        },

        methods: {
            proceed() {
                this.$emit('proceed');
            },

            close() {
                this.$emit('close', false);
            }
        }
    }
</script>

